import React from 'react';

const tab = (active) => ({
  padding: '6px 12px', fontSize: 13, border: 0, borderRadius: 4, cursor: 'pointer',
  background: active ? '#0ea5e9' : '#374151', color: '#fff', fontWeight: active ? 700 : 500,
});

export default function FramesBar({ frames, currentFrameIndex, onSelect, onAdd, onDelete, onDurationChange, isGif }) {
  const current = frames[currentFrameIndex];
  return (
    <div style={{ borderTop: '1px solid #374151', background: '#1f2937', color: '#d1d5db', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.8, marginRight: 4 }}>FRAMES</span>
      {frames.map((f, i) => (
        <button key={f.clientKey} style={tab(i === currentFrameIndex)} onClick={() => onSelect(i)}>
          Frame {i + 1}
        </button>
      ))}
      {isGif && <button style={{ ...tab(false), background: '#065f46' }} onClick={onAdd}>+ Add Frame</button>}
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10, fontSize: 12 }}>
        {isGif && current && (
          <>
            <label>Duration (ms):</label>
            <input
              type="number"
              min={50}
              step={50}
              value={current.duration_ms}
              onChange={(e) => onDurationChange(Number(e.target.value))}
              style={{ width: 80, padding: '4px 6px', fontSize: 12, border: '1px solid #4b5563', borderRadius: 4, background: '#111827', color: '#f3f4f6' }}
            />
          </>
        )}
        {isGif && frames.length > 1 && (
          <button onClick={onDelete} style={{ background: '#7f1d1d', color: '#fff', border: 0, padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>
            Delete Frame
          </button>
        )}
        {!isGif && <span style={{ color: '#9ca3af' }}>Enable Animated GIF to add frames</span>}
      </div>
    </div>
  );
}
